import { render, staticRenderFns } from "./CameraSettings.vue?vue&type=template&id=2a46f76c&scoped=true&"
import script from "./CameraSettings.vue?vue&type=script&lang=js&"
export * from "./CameraSettings.vue?vue&type=script&lang=js&"
import style0 from "./CameraSettings.vue?vue&type=style&index=0&id=2a46f76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46f76c",
  null
  
)

export default component.exports